import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

export default {
  getListRoles: async (querys) => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/users/roles`, querys)
    const response = await fetchManager(url)
    return response
  },
  getListUsersByRole: async (roleId, querys) => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/users/roles/${roleId}`, querys)
    const response = await fetchManager(url, {}, { show: 'no' })
    return response
  },
  getListRegionTree: async () => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/users/region/tree`)
    const response = await fetchManager(url)
    return response
  },
  addUserIntoRole: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/users/roles`, {
        method: 'POST',
        data,
      })
    return response
  },
  addCocUserIntoRole: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/users/roles/coc`, {
        method: 'POST',
        data,
      })
    return response
  },
  updateUserIntoRole: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/users/roles`, {
        method: 'PUT',
        data,
      })
    return response
  },
  deleteRoleUser: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/users/roles`, {
        method: 'DELETE',
        data,
      })
    return response
  },
  assignPrincipalUser: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/users/roles`, {
        method: 'PATCH',
        data,
      })
    return response
  }
}
